import { useState } from 'react'

import {
	EuiPopover,
} from '@equipmentshare/ds2'

import StackedAvatars from '../StackedAvatars'

import styles from './quantityPopover.module.css'

export type QuantityPopoverProps = {
	childQuantities: {
		name: string,
		quantity: number,
	}[],
	max?: number,
	name?: string,
	partDescription?: string,
	quantity: number,
	threshold?: number,
	total: number,
}

export default function QuantityPopover( {
	childQuantities = [],
	max,
	name = 'Branch',
	partDescription = '',
	quantity,
	threshold,
	total,
}: QuantityPopoverProps ) {
	const [ isPopoverOpen, setIsPopoverOpen ] = useState( false )

	const togglePopover = () => setIsPopoverOpen( !isPopoverOpen )
	const closePopover = () => setIsPopoverOpen( false )

	const button = (
		<div className={styles.storeIcons} onClick={togglePopover}>
			<StackedAvatars childQuantities={childQuantities} />
		</div>
	)

	return (
		<EuiPopover
			button={button}
			isOpen={isPopoverOpen}
			closePopover={closePopover}
		>
			<div className={styles.popoverContainer}>
				<h4>{partDescription}</h4>
				<table>
					<tbody>
						<tr>
							<th align="left">Store</th>
							<th align="right">Quantity on hand</th>
						</tr>
						<tr>
							<td>{name}</td>
							<td>{quantity}</td>
						</tr>
						{ childQuantities
							.filter( ( child ) => child.quantity )
							.map( ( child ) => (
								<tr key={child.name}>
									<td>{child.name}</td>
									<td>{child.quantity}</td>
								</tr>
							) ) }
					</tbody>
				</table>
				<hr />
				<div className={styles.popoverSummary}>
					<span>Min: {threshold ?? '-'}</span>
					<span>Max: {max ?? '-'}</span>
					<span className={styles.total}>Total: {total}</span>
				</div>
			</div>
		</EuiPopover>
	)
}
